module.exports = __webpack_public_path__ + "static/media/gallery_empty@3x.a0112882.png";